import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import type { ResourcesConfig } from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import config from './config.js';

const domain = `${config.application_name}-${config.environment_name}.auth.${config.AWS_REGION}.amazoncognito.com`;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
      loginWith: {
        oauth: {
          domain,
          scopes: [
            'openid',
            'email',
            'profile',
            `API-Integration/${config.application_name}-${config.environment_name}-api-integration`,
          ],
          redirectSignIn: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/callback`,
            'https://befair.astrazeneca.com/auth/callback',
          ],
          redirectSignOut: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/login`,
            'https://befair.astrazeneca.com/auth/login',
          ],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};

// Configure Amplify BEFORE bootstrapping the Angular application
Amplify.configure(awsConfig);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
